import { getAuthToken } from "./get-auth-token"
import { getRequestOrganization } from "./account-session"

export interface AuthFetchOptions extends RequestInit {
  tokenOverride?: string
}

/**
 * A wrapper around fetch that adds the Authorization header, using
 * `tokenOverride` when provided and otherwise retrieving the current Clerk session token.
 */
export async function authFetch(
  input: RequestInfo | URL,
  init: AuthFetchOptions = {},
): Promise<Response> {
  const { tokenOverride, headers: initHeaders, ...rest } = init
  const organizationId = getRequestOrganization()

  // Prefer a fresh token; only use override if explicitly intended
  let token: string

  if (tokenOverride) {
    token = tokenOverride
  } else {
    try {
      token = await getAuthToken()
    } catch (error) {
      console.error("Failed to get auth token:", error)
      throw Object.assign(new Error("Authentication failed. Please sign in again."), {
        status: 401,
      })
    }
  }

  const headers: HeadersInit = {
    ...(initHeaders || {}),
    ...(organizationId === undefined
      ? {}
      : { "X-Refined-Organization-ID": String(organizationId) }),
    Authorization: `Bearer ${token}`,
  }

  return fetch(input, { ...rest, headers })
}
